import React from "react";
import * as S from "./styles";
export var Tab = function Tab(_ref) {
  var e = _ref.children;
  return React.createElement(S.Tab, null, e);
};
export default Tab;